export default ((context, inject) => {
  var sharedEnv = context.store.getters['sharedEnv/getSharedEnv'];
  var env = {
    local: sharedEnv.env === 'local',
    preprod: sharedEnv.env === 'preprod',
    prod: sharedEnv.env === 'prod'
  };
  inject('isLocal', env.local);
  inject('isPreprod', env.preprod);
  inject('isProd', env.prod);
});